export const getFluidImage = (image) => image.childImageSharp.fluid;
